import React from 'react'
import css from './style.scss'
import {PopupPage} from 'components/container'
import moment from 'moment'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import DatePicker from 'components/shared/datePicker'
import Button from 'components/shared/button'
import api from '../api'

import {goBack} from 'react-router-redux'
import cn from 'classnames'
import store from 'utils/store'

class DownloadPage extends React.Component{
  constructor(props){
    super(props)
    this.handleDates=this.handleDates.bind(this)
    this.handleClick=this.handleClick.bind(this)
    this.state={
      startDate:moment().subtract(7,"days").startOf("day"),
      endDate:moment().endOf("day"),
      ready:true,
      status:"waiting",
      progress:0
    }
  }

  handleClick(){
    api.getStories(
      this.props.account,
      {
        startDate:this.state.startDate.format("YYYY-MM-DD"),
        endDate:this.state.endDate.format("YYYY-MM-DD")
      },
      false).then((results)=>{
        store.dispatch({type:"EXPORT_STORIES", payload:{stories:results, filename: "stories "+ this.props.account.name}})
        store.dispatch(goBack())
      })
  }

  handleDates({startDate,endDate}){
    this.setState({
      startDate,
      endDate,
      ready:true
    })
  }
  render(){
    return (
      <PopupPage noMargins backTo={"/a/"+this.props.account.id+"/settings"}>
      <div className={css.export}>
        <div className={css.export_container}>
          <h3>Export your stories</h3>
          <h5>Select the range that you want to export:</h5>
          <DatePicker
            inline
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onDatesChange={this.handleDates}
          />
          <Button onClick={this.handleClick} primary className={css.exportButton}>export stories</Button>
        </div>
        <div className={css.export_status} id="status">
          <div className={cn(css.status, css.waiting)}>
            <p>
              Select the data range that you want to download and then click <b>"export your stories"</b>.
            </p>
            <p>Inside the downloaded zip, you will find:</p>
            <ul>
              <li>- A <b>CSV file</b> with all the analytics information about your stories</li>
              <li>- A folder with all your images and video.</li>
            </ul>
          </div>
        </div>
      </div>
    </PopupPage>
    )
  }
}

const mapStateToProps = function (state, props) {
  let account=state.accounts[props.match.params.id]
  return {
    account
  };
}

export default connect(mapStateToProps)(withRouter(DownloadPage));



// WEBPACK FOOTER //
// ./src/components/account_page/download/index.js